import { useTranslationsContext } from '../context/TranslationsContext';

export const useTranslations = () => useTranslationsContext();
